import assetVersions from "@take-2/assets/versions" with { type: "json" }

          
          
          const _fn = () => {
    "";
  };
          export default function renderCreator(_swig, _filters, _utils) {
            return function anonymous(_ctx
) {
  var _imports = {  };
  var _ext = _swig.extensions,
    _output = "";
_output += "<ol class=\"theaters-module__theater-list\">\n  ";
(function () {
  var __l = ((typeof _ctx.Array !== "undefined") ? _ctx.Array : ((typeof Array !== "undefined") ? Array : _fn))(6), __len = (_utils.isArray(__l) || typeof __l === "string") ? __l.length : _utils.keys(__l).length;
  if (!__l) { return; }
    var _ctx__loopcached79273a0f0d12f439d23c4c1bf46c61c = { loop: _ctx.loop, x: _ctx.x, __k: _ctx.__k };
    _ctx.loop = { first: false, index: 1, index0: 0, revindex: __len, revindex0: __len - 1, length: __len, last: false };
  _utils.each(__l, function (x, __k) {
    _ctx.x = x;
    _ctx.__k = __k;
    _ctx.loop.key = __k;
    _ctx.loop.first = (_ctx.loop.index0 === 0);
    _ctx.loop.last = (_ctx.loop.revindex0 === 0);
    _output += "\n      <li class=\"theaters-module__theater-item theaters-module__theater-item--placeholder\"></li>\n  ";
    _ctx.loop.index += 1; _ctx.loop.index0 += 1; _ctx.loop.revindex -= 1; _ctx.loop.revindex0 -= 1;
  });
  _ctx.loop = _ctx__loopcached79273a0f0d12f439d23c4c1bf46c61c.loop;
  _ctx.x = _ctx__loopcached79273a0f0d12f439d23c4c1bf46c61c.x;
  _ctx.__k = _ctx__loopcached79273a0f0d12f439d23c4c1bf46c61c.__k;
  _ctx__loopcached79273a0f0d12f439d23c4c1bf46c61c = undefined;
})();
_output += "\n</ol>\n";

  return _output;

}
            }
        